module.exports = __webpack_public_path__ + "img/right-foot-angle.caa09f92.png";